// React Imports
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

export default
    combineReducers({
        routing: routerReducer
    });



/** WEBPACK FOOTER **
 ** ./src/reducers/RootReducer.js
 **/